export default {
    localizacoes: [],
    localizacao: {},
    ultimaAtualizacaoLocalizacao: Date
}